/* eslint-disable */
import auth from '../api/auth';
import session from '../api/session';
import store from '../store/store.js';
import {
  LOGIN_BEGIN,
  LOGIN_FAILURE,
  LOGIN_SUCCESS,
  LOGOUT,
  REMOVE_TOKEN,
  SET_TOKEN,
} from './types'

const TOKEN_STORAGE_KEY = 'TOKEN_STORAGE_KEY'
const USERID_STORAGE_KEY = 'USERID_STORAGE_KEY'

const initialState = {
  authenticating: false,
  error: false,
  token: null,
  userid: null
}

const getters = {
  isAuthenticated: state => !!state.token,
  getUserId: state => state.userid
}

const actions = {
  login({ commit }, { email, password }) {
    commit(LOGIN_BEGIN)
    let promise= auth.login(email, password)
      promise.then(({ data }) => {
        commit(SET_TOKEN, data)
      })
      .then(() => commit(LOGIN_SUCCESS))
      .catch(() => commit(LOGIN_FAILURE))
      return promise
  },
  logout(context) {
    return auth.logout()
      .then(() => {
        window.ctxt=context
        context.commit('user/clean',null, { root: true })
        context.commit(LOGOUT)
      })
      .finally(() => context.commit(REMOVE_TOKEN))
  },
  initialize({ commit }) {
    const token = localStorage.getItem(TOKEN_STORAGE_KEY)
    const userid = parseInt(localStorage.getItem(USERID_STORAGE_KEY))
    if (token) {
      commit(SET_TOKEN, {'key':token, 'user':userid})
    } else {
      commit(REMOVE_TOKEN)
    }
  },
  resetPassword(context,email) {
    return auth.sendAccountPasswordResetEmail(email)
  },
  resetPasswordConfirm(context, {uid, token, new_password1, new_password2} ) {
    return auth.resetAccountPassword( uid, token, new_password1, new_password2 )
  }
}

const mutations = {
  [LOGIN_BEGIN](state) {
    state.authenticating = true
    state.error = false
  },
  [LOGIN_FAILURE](state) {
    state.authenticating = false
    state.error = true
  },
  [LOGIN_SUCCESS](state) {
    state.authenticating = false
    state.error = false
  },
  [LOGOUT](state) {
    state.authenticating = false
    state.error = false
    state.userid = null
    state.userInfo = null
    state.token= null
    localStorage.removeItem('projectId')
  },

  [SET_TOKEN](state, token_user_obj) {
    const token=token_user_obj.key
    const userid=token_user_obj.user
    //console.log("data.user settoken  :"+ token_user_obj +" " + data.user)
    localStorage.setItem(TOKEN_STORAGE_KEY, token)
    localStorage.setItem(USERID_STORAGE_KEY, userid)
    session.defaults.headers.Authorization = `Token ${token}`
    state.token = token
    state.userid = userid
  },
  [REMOVE_TOKEN](state) {
    localStorage.removeItem(TOKEN_STORAGE_KEY)
    localStorage.removeItem(USERID_STORAGE_KEY)
    delete session.defaults.headers.Authorization
    state.token = null
  },
}

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/auth.js